<template>
  <!-- App.vue -->
  <v-app>
    <!-- Provides the application the proper gutter -->
    <v-main>
      <!-- Sizes your content based upon application components -->
      <v-navigation-drawer
        app
        enable-resize-watcher
        v-model="drawer"
        :clipped="clipped"
        color="#353334"
        v-if="is_auth"
      >
        <!-- -->
        <app-sidebar class="sidebar">enable-resize-watcher </app-sidebar>
      </v-navigation-drawer>

      <!-- -->
      <app-topbar @expandMenu="expandMenu($event)" v-if="is_auth"></app-topbar>

      <!-- If using vue-router -->
      <router-view></router-view>
    </v-main>

    <p class="version">Version {{ version }}</p>
  </v-app>
</template>

<script>
import AppSideBar from "./backend/components/menu/sideBarMenu";
import AppTopBar from "./backend/components/menu/topBarMenu";

export default {
  name: "app",
  components: {
    "app-sidebar": AppSideBar,
    "app-topbar": AppTopBar,
  },
  data() {
    return {
      drawer: true,
      clipped: false,
      version: process.env.VUE_APP_VERSION,
      //isAuth: this.$cookies.get("isAuth"),
    };
  },
  computed: {
    is_auth() {
      console.log(this.$store.getters.is_auth);
      console.log(this.$store.getters.is_auth === true);

      return this.$store.getters.is_auth;
    },
  },
  methods: {
    expandMenu(expand) {
      //console.log("expandMenu App.vue");
      this.drawer = expand;
    },
  },
  mounted() {
    console.log("App");
    if(!this.is_auth)  this.$router.push("/");
    //console.log(this.$cookies);
  },
  watch: {
  /*
    is_auth: {
      handler(val) {
        console.log("is_auth " + val);
        if (!val) {
          this.$route.push("/");
        }
      },
    },
  */
    // isAuth: {
    //   handler(newVal) {
    //     console.log("isAuth");
    //     if (newVal) {
    //       this.isAuth = newVal;
    //     }
    //   },
    // },
  },
};
</script>

<style lang="css">
@import url("https://fonts.googleapis.com/css2?family=Prompt:wght@200;300;400&display=swap");

#app {
  font-family: Prompt, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

.sidebar {
  background-color: #353334;
}
body{
        background-color:#FFFFFF;
},
p,
li,
dd,
dt {
  max-width: 50ch;
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 1.5;
}

small {
  font-size: max(0.5em, 0.8rem);
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  line-height: 1.25;
}

h1,
h2,
h3 {
  font-weight: lighter;
  letter-spacing: 0.05em;
}

h1 {
  font-size: 4rem;
  max-width: 17ch;
}

h2 {
  font-size: 3rem;
  max-width: 25ch;
}

h3 {
  font-size: 2rem;
  max-width: 30ch;
}

h4 {
  font-size: 1.75rem;
  max-width: 30ch;
}
h5 {
  font-size: 1.5rem;
  max-width: 35ch;
}
h6 {
  font-size: 1.25rem;
  max-width: 40ch;
}

ol,
ul,
dl {
  display: grid;
  grid-gap: 1rem;
  gap: 1rem;
}

li,
dd {
  max-width: 40ch;
}

li::marker,
dd::marker {
  color: hsl(200, 50%, 50%);
}

dt {
  font-weight: bolder;
}

dt:not(:first-of-type) {
  margin-top: 2ch;
}

p.version {
  margin-left: auto;
  margin-right: auto;
  font-size: 0.6rem;
}

.headline.form::before {
  content: "";
  padding-right: 5px;
}
.headline.form {
  text-transform: uppercase;
}

.sideBarMenu .v-list-item .v-list-item__title,
.sideBarMenu .v-list-item .v-list-item__subtitle,
.sidebarMenu .v-list-item__icon i.v-icon {
  text-align: left;
  color: #ffffff;
}

.v-card__title {
  text-transform: uppercase;
}

input[type="text"] {
  padding: 2px;
}

.v-data-table-header th{
        background-color:#D6D6D6;
}

/*
.v-btn__content{
        color:#fff;
}
*/
</style>
